export default [
    {
        path: '/customer/marketing-channel',
        props: true,
        component: () => import('@/views/Customer/MarketingChannel'),
    },
];